var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRefresh = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 21 29"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "Forma 1",
  d: "M10.5 3.954V0L5.24 5.273l5.26 5.272V6.59a7.92 7.92 0 0 1 7.88 7.909 8.59 8.59 0 0 1-.92 3.691l1.97 1.977A11.805 11.805 0 0 0 21 14.5 10.557 10.557 0 0 0 10.5 3.954zm0 18.454a7.914 7.914 0 0 1-7.88-7.909 8.45 8.45 0 0 1 .92-3.691L1.57 8.831a11.81 11.81 0 0 0-1.58 5.668A10.559 10.559 0 0 0 10.5 25.044V29l5.25-5.273-5.25-5.273v3.955z",
  fill: "currentColor",
  fillRule: "evenodd"
})));
export default SvgRefresh;